/* Util class to factorise code*/
import $ from "jquery";
import { isMobile } from "react-device-detect";
import { createDeleteElementAction } from "../history/element.history";

const maxWidthORHeightCorner = isMobile ? 150 : 100;

function deleteItemUtil(item: any, context: any) {

    const { removeItem, selectedItem, setSelectedItem, setOpenAbsoluteMenuSection, setIsElevationPresent, setChartRef
    } = context;

    //if not item pass as parameter, element to delete is selectedItem
    const elemToDelete = item != null ? item : selectedItem;

    //on ferme le menu si il est ouvert, avant de supprimer, pour éviter undefined
    if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection('');

    if (elemToDelete != null && removeItem != null) {
        if (elemToDelete.classList != undefined && elemToDelete.classList.contains('elevation-element')) {
            if (setIsElevationPresent) setIsElevationPresent(false);
            if (removeItem) removeItem(elemToDelete.id);
            if (setChartRef) setChartRef(null);
        }
        else {
            //if it is selectedItem to remove, remove it from selectedItem state
            if (setSelectedItem != null && item == null) setSelectedItem(null);
            removeItem(elemToDelete.id);
            //supprimer le clone
            $("#clone-" + elemToDelete!.id).remove();
        }

    }
    else { alert("Aucun élément n'est sélectionné ou l'élement n'est pas supprimable.") }
}

//elem = "movecard" ou "stylocard"
function calcMoveCardPosition(position: any, item: any, zoomValue: any, width: any, height: any, elem: any) {

    var sizeMoveCard = isMobile ? 30 / zoomValue : 30 / zoomValue;

    var moveCardSize = sizeMoveCard / 2;

    var elemW = null;
    var elemH = null;

    var elemX = position == null ? item.x : position.x;
    var elemY = position == null ? item.y : position.y;

    if (width != null && height != null) {
        elemW = width; elemH = height;

        if (typeof elemW === 'string' && elemW.includes("px")) elemW = parseInt(elemW.replace("px", ""))
        if (typeof elemH === 'string' && elemH.includes("px")) elemH = parseInt(elemH.replace("px", ""))

    } else if (item.type == "text-element") {
        let article = $('#' + item.id)!.find("div");
        elemW = article.width(); elemH = article.height();

        //seulement si on a pas le position, c'est que l'on vient de l'init MoveCard, sinon, dans les autres appels, on a déjà recalculer les positions
        if (item.type == "text-element" && item.rotate != null && (item.rotate == 90 || item.rotate == 270) && position == null) {

            //si il y a rotate, l'update de la position de l'item, doit etre celle sans rotate (car rotate est un element transform)
            //let calc2 = rotate90(item.x, item.y, article.height(), article.width());
            var calc = calcPosition(item.id, {x: item.x, y: item.y})
            elemX = calc.position.x;
            elemY = calc.position.y;

            elemW = calc.w; elemH = calc.h;
        }
    }
    else {
        elemW = item.width; elemH = item.height;

        if (typeof elemW === 'string' && elemW.includes("px")) elemW = parseInt(elemW.replace("px", ""))
        if (typeof elemH === 'string' && elemH.includes("px")) elemH = parseInt(elemH.replace("px", ""))

        //pour les images par exemples, on set seulement width pour garder le ratio, donc il faut aller chercher la hauteur
        if (isNaN(elemW)) elemW = $('#' + item.id).width();
        if (isNaN(elemH)) elemH = $('#' + item.id).height();
    }

    var x = 0;
    var y = 0;

    if (elem == "movecard") {
        //obj x + la moitié de sa taille - la moitié de la taille du move card
        x = elemX + elemW / 2 - moveCardSize;
        y = (elemY + elemH) + moveCardSize;
    }
    else if (elem == "stylocard") {
        //obj x + la moitié de sa taille - la moitié de la taille du move card
        x = elemX + elemW + moveCardSize;
        y = (elemY + elemH / 2) - moveCardSize;
    }

    return { x: x, y: y }
}

//elem = "movecard" ou "stylocard"
function calcItemPositionByMoveCard(position: any, item: any, zoomValue: any, elem: any) {

    var sizeMoveCard = isMobile ? 30 / zoomValue : 30 / zoomValue;

    var moveCardSize = sizeMoveCard / 2;

    var elemW = null;
    var elemH = null;
    var positionX = position.x;
    var positionY = position.y;

    if (item.type == "text-element") {
        /**/let article = $('#' + item.id)!.find("div");
        elemW = article.width(); elemH = article.height();

        let angle = getRotationDegrees(article);

        if (angle === 90 || angle === 270) {
            elemW = article.height(); elemH = article.width();
        }
    }
    else {
        elemW = item.width; elemH = item.height;

        //certains element width ou height attaché un a item, sont de type string
        if (typeof elemW === 'string' && elemW.includes("px")) elemW = parseInt(elemW.replace("px", ""))
        if (typeof elemH === 'string' && elemH.includes("px")) elemH = parseInt(elemH.replace("px", ""))

        //pour les images par exemples, on set seulement width pour garder le ratio, donc il faut aller chercher la hauteur
        if (isNaN(elemW)) elemW = $('#' + item.id).width();
        if (isNaN(elemH)) elemH = $('#' + item.id).height();
    }

    var x = 0;
    var y = 0;

    if (elem == "movecard") {
        //obj x + la moitié de sa taille - la moitié de la taille du move card
        x = positionX - elemW / 2 + moveCardSize;
        y = positionY - elemH - moveCardSize;
    }
    else if (elem == "stylocard") {
        //obj x + la moitié de sa taille - la moitié de la taille du move card
        x = positionX + elemW / 2 + moveCardSize * 2;
        y = positionY - elemH / 2 - moveCardSize * 2;
    }


    return { x: x, y: y }
}

//factory function for handle clone and corner resize
//isFinish make the distinct between event on process and event stop
function handleCloneAndCornerPosition(item: any, position: any, width: any, height: any, isFinish: any, zoomValue: any) {

    let cloneDiv = $("#clone-" + item!.id);
    var calcMoveCardP = null;

    //cas spécial pour text-element dont on ne pas modifier la taille sans ecrire
    if (item.type == "text-element") {
        //maj border active
        var calc = calcPosition(item.id, position)

        let w = calc.w;
        let h = calc.h;
        let x = calc.position.x;
        let y = calc.position.y;
        let newPosition = calc.position;

        //move spanClone into an above div (1er plan)
        //cloneDiv.css({ top: position.y, left: position.x, width: w as any, height: h as any, position: 'absolute' });
        cloneDiv.css({ top: y, left: x, width: w as any, height: h as any, position: 'absolute' });

        if (isFinish) {
            calcMoveCardP = calcMoveCardPosition(newPosition, item, zoomValue, w, h, "movecard");

            //replace stylo button
            var calcPositionStylo = calcMoveCardPosition(newPosition, item, zoomValue, w, h, "stylocard");
            $("#stylo-" + item!.id).show();
            $("#stylo-" + item!.id).css('top', calcPositionStylo.y);
            $("#stylo-" + item!.id).css('left', calcPositionStylo.x);
        }
        else {
            cloneDiv.find("div[class^='corner-resize-']").hide();
            $("#movecard-" + item.id).hide();
            $("#stylo-" + item.id).hide();
        }
    }
    else {

        if (width < maxWidthORHeightCorner || height < maxWidthORHeightCorner)
            cloneDiv.find(".corner-resize-bottomLeft").show();
        else
            cloneDiv.find("div[class^='corner-resize-']").show();

        //move spanClone into an above div (1er plan)
        cloneDiv.css({ top: position.y, left: position.x, width: width, height: height, position: 'absolute' });

        if (isFinish) calcMoveCardP = calcMoveCardPosition(position, item, zoomValue, width, height, "movecard");
        else {
            cloneDiv.find("div[class^='corner-resize-']").hide();
            $("#movecard-" + item.id).hide();
        }
    }

    //move clone card
    if (isFinish && calcMoveCardP != null) {
        item.rndClone.current.updatePosition({ x: calcMoveCardP.x, y: calcMoveCardP.y });
        $("#movecard-" + item.id).show();
        $("#stylo-" + item.id).show();
    }
}

function calcPosition(id: any, position: any) {

    let article = $('#' + id)!.find("div");
    let angle = getRotationDegrees(article);

    if (angle === 90 || angle === 270) {
        let calc = rotate90(position.x, position.y, article.width(), article.height());

        return {
            position: { x: calc.x, y: calc.y },
            w: calc.width,
            h: calc.height,
        };
    }

    return {
        position: { x: position.x, y: position.y },
        w: article.width(),
        h: article.height(),
    };
}

function getRotationDegrees($el: any) {
    const transform = $el.css('transform');

    if (transform === 'none') return 0;

    const values = transform.match(/matrix\(([^)]+)\)/)[1].split(',');
    const a = values[0];
    const b = values[1];

    const angle = Math.round(Math.atan2(b, a) * (180 / Math.PI));
    return angle < 0 ? angle + 360 : angle;
}

function rotate90(x: any, y: any, width: any, height: any) {
    const cx = x + width / 2;
    const cy = y + height / 2;

    return {
        x: cx - height / 2,
        y: cy - width / 2,
        width: height,
        height: width,
    };
}




export { deleteItemUtil, calcMoveCardPosition, calcItemPositionByMoveCard, handleCloneAndCornerPosition, calcPosition };